import { Injectable, isDevMode } from '@angular/core';
import { DevAWSSettings, ProdAWSSettings } from 'src/awsconfig';
import { ApiResponse } from 'src/app/shared-models/api-response.model';
import { API } from "aws-amplify";
import { SalesMailRankResult } from './rank.model';

@Injectable({
  providedIn: 'root'
})
export class RankService {

  readonly apiName = "SalesMailUser"
  readonly apiVersion = "2016-04-18";
  readonly awsRegion = "us-east-1";
  public setting = isDevMode() ? new DevAWSSettings() : new ProdAWSSettings();
  
  constructor() { }


  public async getUserRank(): Promise<SalesMailRankResult> {
    const path = `/gamification`;
    const response: ApiResponse<SalesMailRankResult> = await API.get(this.apiName, path, {});
    return response.value as SalesMailRankResult;
  }

}
